import { render, staticRenderFns } from "./Fab.vue?vue&type=template&id=440715ad&scoped=true&"
import script from "./Fab.vue?vue&type=script&lang=js&"
export * from "./Fab.vue?vue&type=script&lang=js&"
import style0 from "./Fab.vue?vue&type=style&index=0&id=440715ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440715ad",
  null
  
)

export default component.exports